"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldErrorMessage = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importDefault(require("react"));
var icon_1 = require("./styled/icon");
var root_1 = require("./styled/root");
var FieldErrorMessage = function (_a) {
    var className = _a.className, __UIScope = _a.__UIScope, errorMessage = _a.errorMessage, id = _a.id, isInverse = _a.isInverse;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'FieldErrorMessage',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement(root_1.Root, { role: "alert", pattern: "caption", element: "div", color: isInverse ? 'utility-error_inverse' : 'utility-error', className: rootClasses, id: id },
        react_1.default.createElement(icon_1.CenteredIcon, { name: "alert", title: "Error message", color: isInverse ? 'utility-error_inverse' : 'utility-error' }),
        errorMessage));
};
var FieldErrorMessageWithSpace = (0, ui_helper_with_space_1.withSpace)(FieldErrorMessage);
exports.FieldErrorMessage = FieldErrorMessageWithSpace;
//# sourceMappingURL=field-error-message.js.map